export default __webpack_public_path__ + "0411fb538ed213d65bb649a276b0b508.svg";